import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import AsyncSelect from 'react-select/async';

import {getResponsableEmpleadoAPI} from "../../../../consumers/backendApisUrls";
import {mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary} from "../../../../helper/utils";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";

const TableWebBody = ({
                          filas,
                          setFilas,
                          editarFila,
                          allAprobadores,
                          onSubmit,
                          cancelarSubmit,
                          SECTION_NAME
                      }) => {

    return (
        <>
            <tbody className="listar-tbody">
            {filas.map((fila, i) => (
                <tr key={i}>
                    <td className="col-2">
                        <div className="mt-2 ml-3">
                            {fila?.IdNivelAprobacion}
                        </div>
                        <p className="ficha-form-input-validation-message"
                           id={`ficha-edit-${SECTION_NAME}-IdNivelAprobacion-validation-message`}></p>
                    </td>
                    <td className="col-3">
                        <AsyncSelectInputOnMap
                            api={getResponsableEmpleadoAPI}
                            placeholder="Buscar o seleccionar aprobador"
                            defaultOptions={allAprobadores}
                            filas={filas}
                            setFilas={setFilas}
                            id={fila.IdConfiguracionAprobadoresCondiciones}
                            name="IdAprobador"
                            nameD="Aprobador"
                            value={fila.IdAprobador ? {value: fila.IdAprobador, label: fila.Aprobador} : ""}
                            isDisabled={!fila.EstadoEditar}
                        />
                        <p className="ficha-form-input-validation-message"
                           id={`ficha-edit-${SECTION_NAME}-IdAprobador-validation-message`}></p>
                    </td>
                    <td className="col-3">
                        <AsyncSelectInputOnMap
                            api={getResponsableEmpleadoAPI}
                            placeholder="Buscar o seleccionar aprob. Alterno"
                            defaultOptions={allAprobadores}
                            filas={filas}
                            setFilas={setFilas}
                            id={fila.IdConfiguracionAprobadoresCondiciones}
                            name="IdAprobadorAlternativo"
                            nameD="AprobadorAlternativo"
                            value={fila.IdAprobadorAlternativo ? {
                                value: fila.IdAprobadorAlternativo,
                                label: fila.AprobadorAlternativo
                            } : ""}
                            isDisabled={!fila.EstadoEditar}
                        />
                        <p className="ficha-form-input-validation-message"
                           id={`ficha-edit-${SECTION_NAME}-IdAprobadorAlternativo-validation-message`}></p>
                    </td>
                    <td className="col-1">
                        <div className="d-flex justify-content-start mt-2 ml-2">
                            {!fila.EsEditable ? <></> :
                            !fila.EstadoEditar ?
                                <>
                                    <FontAwesomeIcon icon='edit' size="lg" className="hand-pointer mr-3"
                                                     title="Editar configuración" onClick={() => editarFila(fila)}/>
                                </> :
                                <>
                                    <FontAwesomeIcon icon='save' size="lg" className="hand-pointer mr-3" title="Guardar"
                                                     onClick={() => onSubmit(fila)}/>
                                    <FontAwesomeIcon icon='times' size="lg" className="hand-pointer" title="Cancelar"
                                                     onClick={() => cancelarSubmit(fila.IdConfiguracionAprobadoresCondiciones)}/>
                                </>

                            }

                        </div>
                    </td>
                </tr>
            ))}
            </tbody>
        </>)
};

export default TableWebBody;

const AsyncSelectInputOnMap = ({
                                   api,
                                   placeholder,
                                   isDisabled,
                                   defaultOptions,
                                   filas,
                                   setFilas,
                                   id,
                                   name,
                                   nameD,
                                   value
                               }) => {
    const [executePost] = useManagePostRequest();

    const loadOptions = async (inputValue, callback) => {

        if (!inputValue) {
            return callback([]);
        }
        let payload = {Criteria: inputValue ?? ""}
        await executePost(api(), payload, (res) => successCallback(res, callback), false)
    };

    const successCallback = (res, callback) => {
        let data = res?.data;
        let options = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary(data);
        callback(options);
    }

    const handleOnChange = (res) => {
        const newInputFields = filas.map(fila => {
            if (fila.IdConfiguracionAprobadoresCondiciones == id) {
                fila[name] = res?.value;
                fila[nameD] = res?.label;
            }
            return fila;
        });
        setFilas(newInputFields);
    }

    return (
        <>
            <AsyncSelect
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions={defaultOptions}
                placeholder={placeholder}
                onChange={handleOnChange}
                isDisabled={isDisabled}
                value={value}
            />
        </>
    );
}